import { useFormatter } from 'use-intl'
import { ProjectCardProps } from '@components/project/ProjectCard'

const useLocalizedRelativeDate = (
  datetimeString: string | ProjectCardProps['createdAt']
) => {
  const formatter = useFormatter()
  const datetime = new Date(datetimeString as string)

  return formatter.relativeTime(datetime)
}

export default useLocalizedRelativeDate
